import React, { createContext, useContext, useEffect, useState } from 'react';
import api from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('pmcrm_user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) document.documentElement.setAttribute('data-role', user.role);
  }, [user]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('pmcrm_token', data.access_token);
      localStorage.setItem('pmcrm_user', JSON.stringify(data.user));
      setUser(data.user);
      document.documentElement.setAttribute('data-role', data.user.role);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('pmcrm_token');
    localStorage.removeItem('pmcrm_user');
    setUser(null);
    document.documentElement.removeAttribute('data-role');
    window.location.href = '/login';
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function roleHomePath(role) {
  switch (role) {
    case 'owner': return '/owner';
    case 'consultant': return '/consultant';
    case 'tenant': return '/tenant';
    case 'agent': return '/agent';
    case 'admin': return '/admin';
    default: return '/login';
  }
}

// Also export the function so we can refresh the cached user (e.g. after profile edit)
export function refreshCachedUser(user) {
  try { localStorage.setItem('pmcrm_user', JSON.stringify(user)); } catch (e) { /* ignore */ }
}
